CCL.recipientInfoForm = {
  autoload: [
    ['toggleDescription', $('.info-null').length > 0],
    ['selectableDropdown', $('.c-recipient-info-form').length > 0]
  ],

  toggleDescription() {
    $('.info-null').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        const targetElement = $(event.target).parents('.info-null').find('.info-description');
        $(targetElement).slideToggle();
      });
    });
  },
  selectableDropdown() {
    $('.booking-month .selected-item').click((e) => {
      $('#sailingMonths')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-recipient-info-form/recipient-info-form.js